<template>
  <div>
    <skeleton
      v-if="loading"
      class="my-5" />
    <div
      v-if="!loading && items.length != 0"
      class="flex flex-col justify-center">
      <div class="py-3 max-w-xl mx-auto w-full px-0">
        <div class="relative antialiased text-sm font-semibold py-1">
          <!-- Vertical bar running through middle -->
          <div
            class="block bg-center-bar absolute h-full left-1/2 transform -translate-x-1/2" />

          <template
            v-for="item in items"
            :key="item.recordDt">
            <!-- Left section, set by justify-start and sm:pr-8 -->
            <div
              v-if="item.direction == 'IN'"
              class="mt-2">
              <template v-if="item.type == 'activity'">
                <div class="flex flex-row items-center">
                  <template v-if="item.action == 'WORK_START'">
                    <div class="flex justify-start w-full mx-auto items-center">
                      <div class="w-1/2 pr-8">
                        <div
                          class="p-2 bg-box-bar rounded shadow border border-work text-center"
                          @click="modifyActivity(item)" style="cursor: pointer">
                          <div class="absolute inline -ml-6">
                            <template v-if="item.location == 'INSIDE'">
                              🏢
                            </template>
                            <template v-else-if="item.location == 'HOME'">
                              🏠
                            </template>
                            <template v-else-if="item.location == 'OUTSIDE'">
                              🚐
                            </template>
                          </div>
                          {{ item.name }}
                        </div>
                      </div>
                      <div
                        class="rounded-md bg-base-100 bg-box-bar border-work border w-12 h-6 absolute left-1/2 translate-y-0 transform -translate-x-1/2 flex items-center justify-center">
                        {{ item.recordDt.format('HH:mm') }}
                      </div>
                    </div>
                  </template>
                  <template v-if="item.action == 'AWAY_END'">
                    <div class="flex justify-start w-full mx-auto items-center">
                      <div class="w-1/2 pr-8">
                        <div
                          class="p-2 bg-box-bar rounded shadow border border-away text-center"
                          @click="modifyActivity(item)" style="cursor: pointer">
                          <div class="absolute inline -ml-6">
                            <template v-if="item.location == 'INSIDE'">
                              🏢
                            </template>
                            <template v-else-if="item.location == 'HOME'">
                              🏠
                            </template>
                            <template v-else-if="item.location == 'OUTSIDE'">
                              🚐
                            </template>
                          </div>
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="rounded-md bg-base-100 bg-box-bar border-away border w-12 h-6 absolute left-1/2 translate-y-0 transform -translate-x-1/2 flex items-center justify-center">
                      {{ item.recordDt.format('HH:mm') }}
                    </div>
                  </template>
                </div>
              </template>

              <template v-if="item.type == 'tagging'">
                <div class="flex flex-row items-center">
                  <div class="flex justify-start w-full mx-auto items-center">
                    <div class="w-1/2 pr-8">
                      <div
	                      class="p-2 bg-box-bar rounded shadow border border-tagging text-center"
	                      @click="addActivity(item)"
	                      style="cursor: pointer">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="rounded-md bg-base-100 bg-box-bar border-tagging border w-12 h-6 absolute left-1/2 translate-y-0 transform -translate-x-1/2 flex items-center justify-center">
                    {{ item.recordDt.format('HH:mm') }}
                  </div>
                </div>
              </template>
            </div>

            <div
              v-if="item.direction == 'OUT'"
              class="mt-2">
              <template v-if="item.type == 'activity'">
                <div class="flex flex-row items-center">
                  <template v-if="item.action == 'WORK_END'">
                    <div class="flex justify-end w-full mx-auto items-center">
                      <div class="w-1/2 pl-8">
                        <div
                          class="p-2 bg-box-bar rounded shadow border border-work text-center"
                          @click="modifyActivity(item)"
                          style="cursor: pointer">
                          {{ item.name }}
                        </div>
                      </div>
                      <div
                        class="rounded-md bg-base-100 bg-box-bar border-work border w-12 h-6 absolute left-1/2 translate-y-0 transform -translate-x-1/2 flex items-center justify-center">
                        {{ item.recordDt.format('HH:mm') }}
                      </div>
                    </div>
                  </template>

                  <template v-if="item.action == 'AWAY_START'">
                    <div class="flex justify-end w-full mx-auto items-center">
                      <div class="w-1/2 pl-8">
                        <div
                          class="p-2 bg-box-bar rounded shadow border border-away text-center"
                          @click="modifyActivity(item)"
                          style="cursor: pointer">
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="rounded-md bg-base-100 border-away border w-12 h-6 absolute left-1/2 translate-y-0 transform -translate-x-1/2 flex items-center justify-center">
                      {{ item.recordDt.format('HH:mm') }}
                    </div>
                  </template>
                </div>
              </template>

              <template v-if="item.type == 'tagging'">
                <div class="flex flex-row items-center">
                  <div class="flex justify-end w-full mx-auto items-center">
                    <div class="w-1/2 pl-8">
                      <div
                        class="p-2 bg-box-bar rounded shadow border border-tagging text-center"
                        @click="addActivity(item)"
                        style="cursor: pointer">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="rounded-md bg-base-100 bg-box-bar border-tagging border w-12 h-6 absolute left-1/2 translate-y-0 transform -translate-x-1/2 flex items-center justify-center">
                    {{ item.recordDt.format('HH:mm') }}
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import {
    AttendanceTimeline,
    getTimelinesAsync,
  } from '@/services/attendnace-timeline-svc.ts';
  import { loadWithStatusAndErrorHandleAsync } from '@/services/loading-svc.ts';
  import {router} from "@/routes/router.ts";

  const props = defineProps<{
    attendanceId: number;
    date: string;
    empNo?: number;
  }>();

  const loading = ref<boolean>(false);
  const items = ref<AttendanceTimeline[]>([]);

  onMounted(async () => {
    await loadWithStatusAndErrorHandleAsync(
      (status) => {
        loading.value = status;
      },
      async () => {
        items.value = await getTimelinesAsync(
          props.attendanceId,
          props.date,
          props.empNo
        );
      }
    );
  });
	
	async function addActivity(item:AttendanceTimeline) {
		await router.push({
			name: 'AttendanceActivities',
			params: {
				attendanceId: props.attendanceId,
				targetDate: props.date,
			},
			query: {
				recordDt: item.recordDt.format('YYYY-MM-DDTHH:mm'),
				direction: item.direction,
			}
		});
	}
  
  async function modifyActivity(item:AttendanceTimeline) {
	  await router.push({
		  name: 'AttendanceActivities',
		  params: {
			  attendanceId: props.attendanceId,
			  targetDate: props.date,
		  },
		  query: {
			  id: item.activityId,
			  direction: item.direction,
		  }
	  });
  }
</script>

<style scoped lang="scss">
  .bg-center-bar {
    width: 2px;
    background-color: oklch(var(--bc) / 0.1);
  }

  .border-work {
    border-color: oklch(var(--er) / var(--tw-bg-opacity));
  }

  .border-away {
    border-color: oklch(var(--in) / var(--tw-bg-opacity));
  }

  .border-tagging {
    border-color: oklch(var(--bc) / 0.4);
  }
</style>
